import React, { useEffect, useState } from "react";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import './academics.css';

const Acadamics = () => {
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);

  // Fetch the list of PDFs from the backend
  const fetchPDFs = async () => {
    setLoading(true);
    try {
      const response = await fetch("https://gptkpm.in/backend/admin/acadamics.php");
      const data = await response.json();
      setPdfs(data);
    } catch (error) {
      console.error("Error fetching PDFs:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle viewing a specific PDF
  const viewPDF = (fileName) => {
    setSelectedPdf(`https://gptkpm.in/backend/admin/uploads/${fileName}`);
  };

  // Fetch PDFs on component mount
  useEffect(() => {
    fetchPDFs();
  }, []);

  return (
    <>
      <Header />
      <div className="academics-container">
        {/* PDF Viewer */}
        <div className="pdf-viewer">
          {selectedPdf ? (
            <iframe
              src={selectedPdf}
              title="PDF Viewer"
              style={{ width: "100%", height: "600px", border: "none" }}
            />
          ) : (
            <p className="pdf-placeholder">Select a PDF to view it here.</p>
          )}
        </div>

        {/* PDF List */}
        <div className="pdf-list">
          <h1>Uploaded PDFs</h1>
          {loading && <p className="loading">Loading...</p>}
          {!loading && pdfs.length === 0 && <p className="no-pdfs">No PDFs available.</p>}
          <ul>
            {pdfs.map((pdf) => (
              <li
                key={pdf.id}
                className="pdf-item"
                onClick={() => viewPDF(pdf.file_name)}
              >
                <span>{pdf.curriculum}</span>
                <span className="file-name">{pdf.file_name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Acadamics;
